import styled from 'styled-components'
import { themeGet } from 'styled-system'
import Container from '../../../components/Container'

export const Title = styled.h4`
  color: ${themeGet('colors.darkBlue')};
  font-size: 2rem;
  font-family: ${themeGet('headerFontFamilySemibold')};
  font-weight: 600;
  letter-spacing: 0.0313rem;
  padding-bottom: 1rem;
  margin-left: 1.25rem;
`

export const Description = styled.div`
  margin-left: 1.25rem;
  padding-bottom: 1rem;
`

export const SitePickerContainer = styled(Container)`
  padding: 0 1.25rem 1.5rem;
`

export const UserCount = styled.span`
  display: flex;
  font-family: ${themeGet('fontFamilySemibold')};
  margin-left: 1.25rem;
`

export const TextLinkContainer = styled(Container).attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 1.25rem 1.25rem 0.6875rem;
`

export const StyledTextLinkDashboard = styled.a.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  font-family: ${themeGet('fontFamily')};
  color: ${themeGet('colors.darkGray')};
  text-decoration: none;

  &:hover {
    color: ${themeGet('colors.secondStepBlue')};
  }
`

export const PageHeaderContainer = styled(Container)`
  padding: 0 1.25rem 1.5rem;
`

export const PageTitle = styled.h1`
  font-family: ${themeGet('fontFamilySemibold')};
  font-size: 1.5rem;
  color: ${themeGet('colors.darkGray')};
  margin: 0;
  padding: 0 0 1rem 0;
`

export const SiteInfoContainer = styled(Container)`
  padding: 0 1.25rem 1rem;
  background-color: ${themeGet('colors.lightGray')};
  border-radius: 0.25rem;
  margin: 0 1.25rem 1rem;
`

export const SiteInfoText = styled.p`
  font-family: ${themeGet('fontFamily')};
  font-size: 0.875rem;
  color: ${themeGet('colors.darkGray')};
  margin: 0;
`

export const TableContainer = styled(Container)`
  position: relative;
  overflow: visible;
  padding: 0;
  margin: 0 1.5rem 0.75rem;
  width: auto;
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`

export const NoDataContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding: 2rem;
`

export const NoDataText = styled.p`
  font-family: ${themeGet('fontFamily')};
  font-size: 1rem;
  color: ${themeGet('colors.darkGray')};
  text-align: center;
  margin: 0;
`

export const StyledTextLink = styled.button.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
  role: 'link',
  type: 'button',
}))`
  align-items: center;
  background-color: transparent;
  border: none;
  display: flex;
  font-family: ${themeGet('fontFamilySemibold')};
  font-size: 1rem;
  color: ${themeGet('colors.blue')};
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:hover svg {
    color: ${themeGet('colors.secondStepBlue')};
  }
`
